import React, { ReactElement } from 'react';
import { Container } from '@sm/wds-react';

import { HeaderTypeEnum, HeaderImagePropsType } from '../../types';

const Logo = (props: HeaderImagePropsType): ReactElement | null => {
  const { headerType, url, altText } = props;
  if (!url) {
    return null;
  }
  const isPremium = headerType === HeaderTypeEnum.PREMIUM;
  return (
    <Container className="sm-enterprise-thank-you__header-logo" flex flexJustify="center">
      {isPremium ? (
        <img data-testid="Logo__Premium" className="sm-enterprise-thank-you__logo" src={url} alt={altText || ''} />
      ) : (
        <img data-testid="Logo__Standard" className="sm-enterprise-thank-you__logo" src={url} alt={altText || ''} />
      )}
    </Container>
  );
};

export default Logo;
